import CountUp from 'react-countup'
import { Building2, TrendingUp, RefreshCw, AlertTriangle, Star } from 'lucide-react'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getCountData } from '../../../feature/dashboard/DashboardSlice'

function StatCounters({ month, year }) {
    const dispatch = useDispatch()
    const { countData } = useSelector((state) => state.dashboards)
    const {
        totalDaycares,
        revenue,
        renewals,
        pendingActions
    } = countData || {}

    console.log("countData", countData)
    useEffect(() => {
        dispatch(getCountData({ month, year }))
    }, [month, year])



    return (
        <div style={{ marginBottom: 16 }}>
            <style>{`
    .stat-cards {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 16px;
        margin-bottom: 16px;
    }

    @media (min-width: 768px) {
        .stat-cards {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (min-width: 1200px) {
        .stat-cards {
            grid-template-columns: repeat(3, 1fr);
        }
    }

    @media (min-width: 1600px) {
        .stat-cards {
            grid-template-columns: repeat(4, 1fr);
        }
    }

    .bottom-cards {
        display: grid;
        gap: 16px;
        grid-template-columns: repeat(1, 1fr);
    }

    @media (min-width: 1600px) {
        .bottom-cards {
            grid-template-columns: repeat(4, 1fr);
        }
    }
`}</style>
            {/* Top row: 3 cards */}
            <div className="stat-cards">
                {/* Total Daycares */}
                <div style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #6366f1 100%)', borderRadius: 16, padding: '20px 24px', color: '#fff', minHeight: 160 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <Building2 size={18} />
                            <span style={{ fontSize: 12, fontWeight: 700, letterSpacing: 1, opacity: 0.9 }}>TOTAL DAYCARES</span>
                        </div>
                        <span style={{ fontSize: 12, fontWeight: 700, background: 'rgba(255,255,255,0.2)', borderRadius: 20, padding: '3px 10px' }}>↑ {totalDaycares?.growthPercentage ?? 0}%</span>
                    </div>
                    <div style={{ fontSize: 32, fontWeight: 800, lineHeight: 1.1, marginBottom: 14 }}>
                        <CountUp end={(totalDaycares?.active + totalDaycares?.inactive) ?? 0} duration={2} separator="," />
                    </div>
                    <div style={{ height: 6, borderRadius: 4, background: '#facc15', overflow: 'hidden', marginBottom: 8 }}>
                        <div style={{ width: `${Math.min(totalDaycares?.growthPercentage ?? 0, 100)}%`, height: '100%', background: '#fff', borderRadius: 4 }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, opacity: 0.9 }}>
                        <span><strong>{totalDaycares?.active ?? 0}</strong> active</span>
                        <span><strong>{totalDaycares?.inactive ?? 0}</strong> inactive</span>
                    </div>
                </div>

                {/* Recurring Revenue */}
                <div style={{ background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)', borderRadius: 16, padding: '20px 24px', color: '#fff', minHeight: 160 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <TrendingUp size={18} />
                            <span style={{ fontSize: 12, fontWeight: 700, letterSpacing: 1, opacity: 0.9 }}>RECURRING REVENUE</span>
                        </div>
                        <span style={{ fontSize: 12, fontWeight: 700, background: 'rgba(255,255,255,0.2)', borderRadius: 20, padding: '3px 10px' }}>↑ {revenue?.growthPercentage ?? 0}%</span>
                    </div>
                    <div style={{ fontSize: 32, fontWeight: 800, lineHeight: 1.1, marginBottom: 14 }}>
                        {revenue?.symbol || '$'}<CountUp end={revenue?.totalRevenue ?? 0} duration={2} separator="," />
                    </div>
                    <div style={{ fontSize: 13, opacity: 0.9, marginBottom: 8 }}>
                        Projected <strong>{revenue?.symbol || '$'}{revenue?.projectedRevenue ?? 0}</strong>
                    </div>
                    {/* <svg width="100%" height="28" viewBox="0 0 160 28" preserveAspectRatio="none">
                        <polyline points="0,24 26,20 52,16 80,12 106,8 132,5 160,2" fill="none" stroke="rgba(255,255,255,0.7)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg> */}
                </div>

                {/* Renewal Rate */}
                <div style={{ background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)', borderRadius: 16, padding: '20px 24px', color: '#fff', minHeight: 160 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <RefreshCw size={18} />
                            <span style={{ fontSize: 12, fontWeight: 700, letterSpacing: 1, opacity: 0.9 }}>RENEWAL RATE</span>
                        </div>
                        <span style={{ fontSize: 12, fontWeight: 700, background: 'rgba(255,255,255,0.2)', borderRadius: 20, padding: '3px 10px' }}>↑ {renewals?.growthPercentage ?? 0}%</span>
                    </div>
                    <div style={{ fontSize: 32, fontWeight: 800, lineHeight: 1.1, marginBottom: 14 }}>
                        <CountUp end={renewals?.renewalRate ?? 0} duration={2} decimals={1} suffix="%" />
                    </div>
                    <div style={{ height: 6, borderRadius: 4, background: 'rgba(255,255,255,0.25)', overflow: 'hidden', marginBottom: 8 }}>
                        <div style={{ width: `${Math.min(renewals?.renewalRate ?? 0, 100)}%`, height: '100%', background: 'rgba(255,255,255,0.85)', borderRadius: 4 }} />
                    </div>
                    <div style={{ fontSize: 13, opacity: 0.9 }}><strong>{renewals?.renewalsDue ?? 0}</strong> renewals due next 30 days</div>
                </div>
                <div style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)', borderRadius: 16, padding: '20px 24px', color: '#fff' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <AlertTriangle size={18} />
                            <span style={{ fontSize: 12, fontWeight: 700, letterSpacing: 1, opacity: 0.9 }}>PENDING ACTIONS</span>
                        </div>
                        <span style={{ fontSize: 12, fontWeight: 700, background: 'rgba(255,255,255,0.25)', borderRadius: 20, padding: '3px 10px' }}>Needs review</span>
                    </div>
                    <div style={{ fontSize: 32, fontWeight: 800, lineHeight: 1.1, marginBottom: 14 }}>
                        <CountUp end={pendingActions?.total ?? 0} duration={2} />
                    </div>
                    <div style={{ display: 'flex', gap: 24, fontSize: 13, opacity: 0.95 }}>
                        <span><strong>{pendingActions?.approvals ?? 0}</strong> approvals</span>
                        <span><strong>{pendingActions?.payments ?? 0}</strong> payments</span>
                        <span><strong>{pendingActions?.enquiries ?? 0}</strong> enquiries</span>
                    </div>
                </div>
            </div>


            {/* Priority Actions Bar */}
            {/* <div style={{ background: 'linear-gradient(90deg, #1e1b4b 0%, #312e81 60%, #4c1d95 100%)', borderRadius: 14, padding: '14px 22px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 16 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <Star size={18} color="#facc15" fill="#facc15" />
                    <span style={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>Priority Actions</span>
                    <span style={{ background: '#6366f1', color: '#fff', borderRadius: 20, padding: '2px 10px', fontSize: 13, fontWeight: 700 }}>14</span>
                    <div style={{ width: 1, height: 20, background: 'rgba(255,255,255,0.15)', margin: '0 4px' }} />
                    {[
                        { label: 'Approvals', count: 5, dot: '#ef4444' },
                        { label: 'Requests', count: 3, dot: '#6366f1' },
                        { label: 'Help Center', count: 2, dot: '#22c55e' },
                        { label: 'Tickets', count: 8, dot: '#a78bfa' },
                    ].map(item => (
                        <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'rgba(255,255,255,0.1)', borderRadius: 20, padding: '4px 12px', cursor: 'pointer' }}>
                            <span style={{ width: 7, height: 7, borderRadius: '50%', background: item.dot, display: 'inline-block' }} />
                            <span style={{ color: '#fff', fontSize: 13, fontWeight: 500 }}>{item.label}</span>
                            <span style={{ color: '#fff', fontSize: 13, fontWeight: 700 }}>{item.count}</span>
                        </div>
                    ))}
                </div>
                <span style={{ color: '#a5b4fc', fontSize: 13, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}>View all →</span>
            </div> */}
        </div>
    )
}

export default StatCounters
